import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import QRCode from "react-qr-code";

import { fetchRedeemCodes, addRedeemCode, updateRedeemCode, deleteRedeemCode } from "../actions/redeemcodes";
import { fetchMachines } from "../actions/machines";
import { fetchCustomersName, fetchCustomer } from "../actions/customers";

import ErrorMessage from "../components/ErrorMessage";
import LoadingProgress from "../components/LoadingProgress";
import FeatureBlockedScreen from "../components/FeatureBlockedScreen";
import "../styles/RedeemCodesView.css";

const LOCKER_TYPES = [
  { code: "BNS", name: "Standard" },
  { code: "CNS", name: "Standard Carga" },
  { code: "BWS", name: "Standard XL" },
  { code: "CWS", name: "Standard Carga XL" },
  { code: "BNM", name: "Medium" },
  { code: "CNM", name: "Medium Carga" },
  { code: "BWM", name: "Medium XL" },
  { code: "CWM", name: "Medium Carga XL" },
  { code: "BNL", name: "Large" },
  { code: "CNL", name: "Large Carga" },
  { code: "BWL", name: "Large XL" },
  { code: "CWL", name: "Large Carga XL" },
  { code: "BNXL", name: "Large 4" },
  { code: "CNXL", name: "Large 4 Carga" },
  { code: "BWXL", name: "Large 4 XL" },
  { code: "CWXL", name: "Large 4 Carga XL" },
  { code: "BN2XL", name: "Large 5" },
  { code: "CN2XL", name: "Large 5 Carga" },
  { code: "BW2XL", name: "Large 5 XL" },
  { code: "CW2XL", name: "Large 5 Carga XL" },
  { code: "BN3XL", name: "Ski" },
  { code: "CN3XL", name: "Ski Carga" },
  { code: "BW3XL", name: "Ski XL" },
  { code: "CW3XL", name: "Ski Carga XL" },
  { code: "XNS", name: "Standard Cupón" },
  { code: "XWS", name: "Standard XL Cupón" },
  { code: "XNM", name: "Medium Cupón" },
  { code: "XWM", name: "Medium XL Cupón" },
  { code: "XNL", name: "Large Cupón" },
  { code: "XWL", name: "Large XL Cupón" },
  { code: "XNXL", name: "Large 4 Cupón" },
  { code: "XWXL", name: "Large 4 XL Cupón" },
  { code: "XN2XL", name: "Large 5 Cupón" },
  { code: "XW2XL", name: "Large 5 XL Cupón" },
  { code: "XN3XL", name: "Ski Cupón" },
  { code: "XW3XL", name: "Ski XL Cupón" },
];

class RedeemCodesView extends React.Component {
  // Helper function to convert date to local datetime-local format
  dateToLocalDatetimeString(date) {
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    const hours = String(d.getHours()).padStart(2, '0');
    const minutes = String(d.getMinutes()).padStart(2, '0');
    return `${year}-${month}-${day}T${hours}:${minutes}`;
  }

  constructor(props) {
    super(props);
    this.state = {
      showForm: false,
      loaded: false,
      showRedeemedModal: false,
      selectedRedeemedCode: null,
      filterCode: "",
      filterCustomer: "",
      filterStatus: "all",
      filterDateFrom: "",
      filterDateTo: "",
      newRedeemCode: {
        customer: "",
        machine: "",
        origin: "internal",
        products: [],
        valid_from: "",
        valid_to: "",
        code: "",
      },
      currentProductId: "",
      currentProductQty: 1,
      editingProductIndex: null,
      showEditModal: false,
      editRedeemCode: null,
      editProductId: "",
      editProductQty: 1,
      editingEditProductIndex: null,
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.toggleForm = this.toggleForm.bind(this);
    this.showQRCode = this.showQRCode.bind(this);
    this.closeQRModal = this.closeQRModal.bind(this);
    this.printTicket = this.printTicket.bind(this);
    this.showRedeemedModal = this.showRedeemedModal.bind(this);
    this.closeRedeemedModal = this.closeRedeemedModal.bind(this);
    this.handleProductChange = this.handleProductChange.bind(this);
    this.addProduct = this.addProduct.bind(this);
    this.removeProduct = this.removeProduct.bind(this);
    this.editProduct = this.editProduct.bind(this);
    this.updateProduct = this.updateProduct.bind(this);
    this.openEditModal = this.openEditModal.bind(this);
    this.closeEditModal = this.closeEditModal.bind(this);
    this.handleEditInputChange = this.handleEditInputChange.bind(this);
    this.handleEditSubmit = this.handleEditSubmit.bind(this);
    this.handleDeleteRedeemCode = this.handleDeleteRedeemCode.bind(this);
    this.handleEditProductChange = this.handleEditProductChange.bind(this);
    this.addEditProduct = this.addEditProduct.bind(this);
    this.removeEditProduct = this.removeEditProduct.bind(this);
    this.editEditProduct = this.editEditProduct.bind(this);
    this.updateEditProduct = this.updateEditProduct.bind(this);
  }

  componentDidMount() {
    const { type, role, customerId, fetchMachines, fetchCustomersName } = this.props;
    this.props.fetchRedeemCodes(role !== 'ADMIN' ? customerId : undefined, 'standard');

    if (role === 'CUSTOMER' && customerId) {
      this.props.fetchCustomer(customerId);
    }

    fetchMachines();

    if (role === "ADMIN" || (role === "CUSTOMER" && type === "GROUP")) {
      fetchCustomersName();
    }

    this.load(this.props);
  }

  componentDidUpdate(prevProps) {
    this.load(this.props);

    if (
      this.props.redeemCodesNeedRefresh &&
      !prevProps.redeemCodesNeedRefresh
    ) {
      const { role, customerId } = this.props;
      this.props.fetchRedeemCodes(role !== 'ADMIN' ? customerId : undefined, 'standard');
    }
  }

  load(props) {
    const { role, machines, customers } = props;

    if (!this.state.loaded && machines && (role !== "ADMIN" || customers)) {
      this.setState({ loaded: true });
    }
  }

  toggleForm() {
    const { role, customerId } = this.props;
    const isOpening = !this.state.showForm;

    if (isOpening) {
      if (role === "ADMIN") {
        this.setState({
          showForm: true,
          newRedeemCode: {
            ...this.state.newRedeemCode,
            customer: "620d1664db950220fabc0a41",
            valid_from: "",
            valid_to: "",
          },
        });
      } else {
        this.setState({
          showForm: true,
          newRedeemCode: {
            ...this.state.newRedeemCode,
            customer: customerId,
            valid_from: "",
            valid_to: "",
          },
        });
      }
    } else {
      this.setState({ showForm: !this.state.showForm });
    }
  }

  handleInputChange(event) {
    const { name, value } = event.target;
    const updated = { ...this.state.newRedeemCode, [name]: value };

    // If valid_to is set and is earlier than valid_from, clear valid_to
    if (name === 'valid_from' && updated.valid_to && value && updated.valid_to < value) {
      updated.valid_to = '';
    }

    this.setState({ newRedeemCode: updated });
  }

  handleSubmit(event) {
    event.preventDefault();
    
    // Sanitize the data before sending
    const sanitizedRedeemCode = {
      ...this.state.newRedeemCode,
      // Machine is always null for new codes
      machine: null,
      // Send null when dates are not selected (code will never expire)
      valid_from: this.state.newRedeemCode.valid_from || null,
      valid_to: this.state.newRedeemCode.valid_to || null,
    };
    
    this.props.addRedeemCode(sanitizedRedeemCode);
    this.setState({
      showForm: false,
      newRedeemCode: {
        customer: "",
        machine: "",
        origin: "internal",
        products: [],
        valid_from: "",
        valid_to: "",
        code: "",
        multiple_redeems: false,
      },
      currentProductId: "",
      currentProductQty: 1,
    });
  }

  showQRCode(redeemCode) {
    this.setState({
      showQRModal: true,
      selectedRedeemCode: redeemCode,
    });
  }

  closeQRModal() {
    this.setState({
      showQRModal: false,
      selectedRedeemCode: null,
    });
  }

  printTicket() {
    const { selectedRedeemCode } = this.state;
    if (!selectedRedeemCode) return;

    const ticketEl = document.getElementById('qr-ticket-print');
    if (!ticketEl) return;

    const win = window.open('', '_blank', 'width=460,height=720');
    win.document.write(`<!DOCTYPE html>
<html>
<head>
  <meta charset="utf-8">
  <title>Vale de Canje - ${selectedRedeemCode.code}</title>
  <style>
    * { margin: 0; padding: 0; box-sizing: border-box; }
    body { font-family: Arial, sans-serif; background: #f3f4f6; display: flex; justify-content: center; padding: 30px; }
    .ticket-voucher { width: 360px; border: 2px solid #e5e7eb; border-radius: 12px; overflow: hidden; background: white; box-shadow: 0 4px 20px rgba(0,0,0,0.15); }
    .ticket-header { background: linear-gradient(135deg, #022040 0%, #0a4080 100%); color: white; padding: 22px 20px 18px; text-align: center; }
    .ticket-brand { font-size: 26px; font-weight: 800; letter-spacing: 4px; margin-bottom: 4px; }
    .ticket-subtitle { font-size: 11px; letter-spacing: 4px; opacity: 0.8; text-transform: uppercase; }
    .ticket-tear { display: flex; align-items: center; position: relative; }
    .ticket-tear .notch { width: 22px; height: 22px; border-radius: 50%; background: #f3f4f6; flex-shrink: 0; margin: 0 -11px; }
    .ticket-tear .dashes { flex: 1; border-top: 2px dashed #d1d5db; background: white; height: 22px; }
    .ticket-body { padding: 22px 24px 18px; background: white; display: flex; flex-direction: column; align-items: center; gap: 12px; }
    .ticket-qr { padding: 10px; border: 1px solid #e5e7eb; border-radius: 8px; background: white; }
    .ticket-qr svg { display: block; }
    .ticket-code-label { font-size: 10px; letter-spacing: 3px; color: #9ca3af; text-transform: uppercase; margin-top: 2px; }
    .ticket-code { font-size: 20px; font-weight: 800; letter-spacing: 4px; color: #022040; font-family: 'Courier New', monospace; text-align: center; word-break: break-all; }
    .ticket-product-chip { background: #e0f0ff; color: #0a4080; padding: 6px 16px; border-radius: 20px; font-size: 13px; font-weight: 700; border: 1px solid #bfdbfe; }
    .ticket-product-chip i { display: none; }
    .ticket-validity { width: 100%; display: grid; grid-template-columns: 1fr 1fr; gap: 12px; border-top: 2px dashed #e5e7eb; padding-top: 14px; margin-top: 4px; }
    .validity-item { display: flex; flex-direction: column; gap: 3px; }
    .validity-item span { font-size: 10px; text-transform: uppercase; letter-spacing: 1px; color: #9ca3af; font-weight: 600; }
    .validity-item strong { font-size: 12px; color: #111827; font-weight: 700; }
    .ticket-footer { background: #f8f9fa; padding: 12px 20px; text-align: center; font-size: 11px; color: #6b7280; border-top: 1px solid #e5e7eb; }
  </style>
</head>
<body>${ticketEl.outerHTML}</body>
</html>`);
    win.document.close();
    win.focus();
    setTimeout(() => { win.print(); win.close(); }, 350);
  }

  showRedeemedModal(redeemCode) {
    this.setState({
      showRedeemedModal: true,
      selectedRedeemedCode: redeemCode,
    });
  }

  closeRedeemedModal() {
    this.setState({
      showRedeemedModal: false,
      selectedRedeemedCode: null,
    });
  }

  getTypeName(type) {
    switch (type) {
      case "BNS":
        return "Standard";
      case "CNS":
        return "Standard Carga";
      case "BWS":
        return "Standard XL";
      case "CWS":
        return "Standard Carga XL";
      case "BNM":
        return "Medium";
      case "CNM":
        return "Medium Carga";
      case "BWM":
        return "Medium XL";
      case "CWM":
        return "Medium Carga XL";
      case "BNL":
        return "Large";
      case "CNL":
        return "Large Carga";
      case "BWL":
        return "Large XL";
      case "CWL":
        return "Large Carga XL";
      case "BNXL":
        return "Large 4";
      case "CNXL":
        return "Large 4 Carga";
      case "BWXL":
        return "Large 4 XL";
      case "CWXL":
        return "Large 4 Carga XL";
      case "BN2XL":
        return "Large 5";
      case "CN2XL":
        return "Large 5 Carga";
      case "BW2XL":
        return "Large 5 XL";
      case "CW2XL":
        return "Large 5 Carga XL";
      case "BN3XL":
        return "Ski";
      case "CN3XL":
        return "Ski Carga";
      case "BW3XL":
        return "Ski XL";
      case "CW3XL":
        return "Ski Carga XL";
      // Voucher/Coupon Types (X and W, no LOCKER prefix)
      case "XNS":
        return "Standard Cupón";
      case "XWS":
        return "Standard XL Cupón";
      case "XNM":
        return "Medium Cupón";
      case "XWM":
        return "Medium XL Cupón";
      case "XNL":
        return "Large Cupón";
      case "XWL":
        return "Large XL Cupón";
      case "XNXL":
        return "Large 4 Cupón";
      case "XWXL":
        return "Large 4 XL Cupón";
      case "XN2XL":
        return "Large 5 Cupón";
      case "XW2XL":
        return "Large 5 XL Cupón";
      case "XN3XL":
        return "Ski Cupón";
      case "XW3XL":
        return "Ski XL Cupón";
      default:
        return "NONE";
    }
  }

  handleProductChange(event) {
    const { name, value } = event.target;
    this.setState({ [name]: value });
  }

  addProduct() {
    const { currentProductId, currentProductQty, newRedeemCode } = this.state;
    if (!currentProductId || !currentProductQty) return;

    const locker = LOCKER_TYPES.find((l) => l.code === currentProductId);
    if (!locker) return;

    const product = {
      product_id: null, // Product ID should be null for locker types
      product_name: currentProductId, // Use locker code (BNS, CNS, etc.) as product_name
      product_qty: parseInt(currentProductQty),
      product_price: 0, // No price for now
    };

    this.setState({
      newRedeemCode: {
        ...newRedeemCode,
        products: [...newRedeemCode.products, product],
      },
      currentProductId: "",
      currentProductQty: 1,
    });
  }

  removeProduct(index) {
    const { newRedeemCode } = this.state;
    const products = [...newRedeemCode.products];
    products.splice(index, 1);
    this.setState({
      newRedeemCode: {
        ...newRedeemCode,
        products,
      },
      editingProductIndex: null,
    });
  }

  editProduct(index) {
    this.setState({ editingProductIndex: index });
  }

  updateProduct(index, productId, productQty) {
    const { newRedeemCode } = this.state;
    const locker = LOCKER_TYPES.find((l) => l.code === productId);
    if (!locker) return;

    const products = [...newRedeemCode.products];
    products[index] = {
      product_id: null, // Product ID should be null for locker types
      product_name: productId, // Use locker code (BNS, CNS, etc.) as product_name
      product_qty: parseInt(productQty),
      product_price: 0,
    };

    this.setState({
      newRedeemCode: {
        ...newRedeemCode,
        products,
      },
      editingProductIndex: null,
    });
  }

  openEditModal(redeemCode) {
    this.setState({
      showEditModal: true,
      editRedeemCode: {
        _id: redeemCode._id,
        customer: redeemCode.customer,
        machine: redeemCode.machine,
        origin: redeemCode.origin || "internal",
        products: [...redeemCode.products],
        valid_from: this.dateToLocalDatetimeString(redeemCode.valid_from),
        valid_to: this.dateToLocalDatetimeString(redeemCode.valid_to),
        code: redeemCode.code,
        multiple_redeems: redeemCode.multiple_redeems === true,
      },
      editProductId: "",
      editProductQty: 1,
      editingEditProductIndex: null,
    });
  }

  closeEditModal() {
    this.setState({
      showEditModal: false,
      editRedeemCode: null,
      editProductId: "",
      editProductQty: 1,
      editingEditProductIndex: null,
    });
  }

  handleEditInputChange(event) {
    const { name, value } = event.target;
    this.setState({
      editRedeemCode: {
        ...this.state.editRedeemCode,
        [name]: value,
      },
    });
  }

  handleEditSubmit(event) {
    event.preventDefault();
    const { editRedeemCode } = this.state;
    const { _id, ...updates } = editRedeemCode;
    
    // Sanitize the data before sending
    const sanitizedUpdates = {
      ...updates,
      // Machine is always null
      machine: null,
    };
    
    this.props.updateRedeemCode(_id, sanitizedUpdates);
    this.closeEditModal();
  }

  handleDeleteRedeemCode(redeemCodeId) {
    if (window.confirm("¿Está seguro de que desea eliminar este código de canje?")) {
      this.props.deleteRedeemCode(redeemCodeId);
    }
  }

  handleEditProductChange(event) {
    const { name, value } = event.target;
    this.setState({ [name]: value });
  }

  addEditProduct() {
    const { editProductId, editProductQty, editRedeemCode } = this.state;
    if (!editProductId || !editProductQty) return;

    const locker = LOCKER_TYPES.find((l) => l.code === editProductId);
    if (!locker) return;

    const product = {
      product_id: null, // Product ID should be null for locker types
      product_name: editProductId, // Use locker code (BNS, CNS, etc.) as product_name
      product_qty: parseInt(editProductQty),
      product_price: 0,
    };

    this.setState({
      editRedeemCode: {
        ...editRedeemCode,
        products: [...editRedeemCode.products, product],
      },
      editProductId: "",
      editProductQty: 1,
    });
  }

  removeEditProduct(index) {
    const { editRedeemCode } = this.state;
    const products = [...editRedeemCode.products];
    products.splice(index, 1);
    this.setState({
      editRedeemCode: {
        ...editRedeemCode,
        products,
      },
      editingEditProductIndex: null,
    });
  }

  editEditProduct(index) {
    this.setState({ editingEditProductIndex: index });
  }

  updateEditProduct(index, productId, productQty) {
    const { editRedeemCode } = this.state;
    const locker = LOCKER_TYPES.find((l) => l.code === productId);
    if (!locker) return;

    const products = [...editRedeemCode.products];
    products[index] = {
      product_id: null, // Product ID should be null for locker types
      product_name: productId, // Use locker code (BNS, CNS, etc.) as product_name
      product_qty: parseInt(productQty),
      product_price: 0,
    };

    this.setState({
      editRedeemCode: {
        ...editRedeemCode,
        products,
      },
      editingEditProductIndex: null,
    });
  }

  getMachineSerial(machineId) {
    const { machines } = this.props;
    if (!machines || !machineId) return machineId;
    const machine = machines.find((m) => m._id === machineId);
    return machine ? machine.Serial : machineId;
  }

  getCustomerName(customerId) {
    const { role, customers, customerFullname } = this.props;
    if (role !== 'ADMIN') return customerFullname || 'Unknown';
    if (!customers || !customerId) return "Unknown";
    const customer = customers.find((c) => c._id === customerId);
    return customer ? customer.Fullname : "Unknown";
  }

  getCodeStatus(redeemCode) {
    if (redeemCode.valid_to && new Date(redeemCode.valid_to) < new Date()) return 'expired';
    if (!redeemCode.multiple_redeems && redeemCode.redeemedAt && redeemCode.redeemedAt.length > 0) return 'redeemed';
    return 'pending';
  }

  render() {
    const { role, redeemCodes, loading, error, machines, customers, type, customer } =
      this.props;

    if (role === 'CUSTOMER' && customer && customer.FeatureRedeemCodes === false) {
      return <FeatureBlockedScreen featureName="FeatureRedeemCodes" featureLabel="Códigos Canjeables" />;
    }
    const {
      showForm,
      newRedeemCode,
      loaded,
      showQRModal,
      selectedRedeemCode,
      filterCode,
      filterCustomer,
      filterStatus,
      filterDateFrom,
      filterDateTo,
      showRedeemedModal,
      selectedRedeemedCode,
    } = this.state;

    const filteredRedeemCodes = redeemCodes
      ? redeemCodes.filter(rc => {
          if (filterCode && !rc.code.toLowerCase().includes(filterCode.toLowerCase())) return false;
          if (filterCustomer && rc.customer !== filterCustomer) return false;
          const status = this.getCodeStatus(rc);
          if (filterStatus !== 'all' && status !== filterStatus) return false;
          if (filterDateFrom && rc.valid_from && new Date(rc.valid_from) < new Date(filterDateFrom)) return false;
          if (filterDateTo && rc.valid_to && new Date(rc.valid_to) > new Date(filterDateTo + 'T23:59:59')) return false;
          return true;
        })
      : [];

    if (error) {
      return <ErrorMessage message={error.message} />;
    }

    if (!redeemCodes || loading) {
      return <LoadingProgress />
    }

    if (!loaded) {
      return <LoadingProgress />
    }

    return (
      <div className="redeemcodes-view">
        {/* Header Section */}
        <div className="redeemcodes-header">
          <div className="redeemcodes-title-section">
            <h1 className="redeemcodes-title">
              <i className="fas fa-ticket"></i>
              Códigos Canjeables (Vouchers)
            </h1>
          </div>
          <div className="redeemcodes-actions">
            <button className="btn btn-vw btn-action" onClick={this.toggleForm}>
              <i
                className={`fas ${
                  showForm ? "fa-times" : "fa-plus-circle"
                } mr-2`}
              ></i>
              {showForm ? "Cancelar" : "Añadir Código de Canje"}
            </button>
          </div>
        </div>

        {showForm && (
          <div className="vw-modal">
            <div className="vw-modal__backdrop" onClick={this.toggleForm} />
            <div className="vw-modal__dialog rc-create-modal">
              <div className="vw-modal__header rc-modal-header">
                <div className="rc-modal-header__title">
                  <div className="rc-modal-header__icon">
                    <i className="fas fa-ticket"></i>
                  </div>
                  <div>
                    <h5 className="m-0">Crear Código de Canje</h5>
                    <span className="rc-modal-header__sub">Configura el nuevo voucher</span>
                  </div>
                </div>
                <button
                  type="button"
                  className="rc-modal-close"
                  onClick={this.toggleForm}
                  aria-label="Close"
                >
                  <i className="fas fa-times"></i>
                </button>
              </div>
              <div className="vw-modal__body">
                <form onSubmit={this.handleSubmit}>
                  {role === "ADMIN" && (
                    <div className="rc-form-group">
                      <label className="rc-form-label">
                        <i className="fas fa-building"></i> Cliente
                      </label>
                      <select
                        className="rc-form-input"
                        name="customer"
                        value={newRedeemCode.customer}
                        onChange={this.handleInputChange}
                        required
                      >
                        <option value="">Seleccionar Cliente</option>
                        {customers &&
                          customers
                            .filter((customer) => customer.Type === "GENERAL" || customer.Type === "LICENCIA_BASICA" || customer.Type === "LICENCIA_PRO")
                            .sort((a, b) => a.Fullname.localeCompare(b.Fullname))
                            .map((customer) => (
                              <option value={customer._id} key={customer._id}>
                                {customer.Fullname}
                              </option>
                            ))}
                      </select>
                    </div>
                  )}
                  <div className="rc-form-group">
                    <label className="rc-form-label">
                      <i className="fas fa-barcode"></i> Código
                    </label>
                    <input
                      type="text"
                      className="rc-form-input"
                      name="code"
                      placeholder="Se generará automáticamente si se deja vacío"
                      value={newRedeemCode.code}
                      onChange={this.handleInputChange}
                    />
                  </div>
                  <div className="rc-form-row-2">
                    <div className="rc-form-group">
                      <label className="rc-form-label">
                        <i className="fas fa-calendar-check"></i> Válido Desde <span className="rc-form-optional">(opcional)</span>
                      </label>
                      <input
                        type="datetime-local"
                        className="rc-form-input"
                        name="valid_from"
                        value={newRedeemCode.valid_from}
                        onChange={this.handleInputChange}
                        min={new Date().toISOString().slice(0, 16)}
                      />
                    </div>
                    <div className="rc-form-group">
                      <label className="rc-form-label">
                        <i className="fas fa-calendar-times"></i> Válido Hasta <span className="rc-form-optional">(opcional)</span>
                      </label>
                      <input
                        type="datetime-local"
                        className="rc-form-input"
                        name="valid_to"
                        value={newRedeemCode.valid_to}
                        onChange={this.handleInputChange}
                        min={newRedeemCode.valid_from || new Date().toISOString().slice(0, 16)}
                      />
                    </div>
                  </div>
                  <p className="rc-form-hint">
                    <i className="fas fa-info-circle"></i>
                    Si no se seleccionan fechas, el código no tendrá fecha de caducidad.
                  </p>
                  <div className="rc-form-group">
                    <label className="rc-form-label">
                      <i className="fas fa-redo"></i> Canje Múltiple
                    </label>
                    <label className="rc-toggle-row">
                      <input
                        type="checkbox"
                        className="rc-toggle-input"
                        name="multiple_redeems"
                        checked={newRedeemCode.multiple_redeems}
                        onChange={e => this.setState({ newRedeemCode: { ...newRedeemCode, multiple_redeems: e.target.checked } })}
                      />
                      <span className="rc-toggle-track"></span>
                      <span className="rc-toggle-label-text">
                        {newRedeemCode.multiple_redeems
                          ? "Activado — el código puede canjearse múltiples veces"
                          : "Desactivado — el código solo puede canjearse una vez"}
                      </span>
                    </label>
                  </div>
                  <div className="rc-form-group">
                    <label className="rc-form-label">
                      <i className="fas fa-box"></i> Producto
                    </label>
                    <div className="rc-product-add-row">
                      <select
                        className="rc-form-input"
                        name="currentProductId"
                        value={this.state.currentProductId}
                        onChange={this.handleProductChange}
                      >
                        <option value="">Seleccionar Producto</option>
                        {LOCKER_TYPES.map((locker) => (
                          <option value={locker.code} key={locker.code}>
                            {locker.name}
                          </option>
                        ))}
                      </select>
                      <input
                        type="number"
                        className="rc-form-input rc-form-input--qty"
                        name="currentProductQty"
                        value={this.state.currentProductQty}
                        onChange={this.handleProductChange}
                        min="1"
                        max="1"
                      />
                      <button
                        type="button"
                        className="btn btn-vw rc-product-add-btn"
                        onClick={this.addProduct}
                        disabled={newRedeemCode.products.length >= 1 || !this.state.currentProductId}
                      >
                        <i className="fas fa-plus"></i>
                      </button>
                    </div>
                    {newRedeemCode.products.length >= 1 && (
                      <p className="rc-form-hint rc-form-hint--warn">
                        <i className="fas fa-exclamation-circle"></i>
                        Solo se permite 1 producto por código
                      </p>
                    )}
                    <div className="rc-product-list">
                      {newRedeemCode.products.map((product, index) => (
                        <div key={index} className="rc-product-item">
                          {this.state.editingProductIndex === index ? (
                            <div className="rc-product-edit-row">
                              <select
                                className="rc-form-input"
                                defaultValue={product.product_id}
                                id={`edit-product-${index}`}
                              >
                                {LOCKER_TYPES.map((locker) => (
                                  <option value={locker.code} key={locker.code}>
                                    {locker.name}
                                  </option>
                                ))}
                              </select>
                              <input
                                type="number"
                                className="rc-form-input rc-form-input--qty"
                                defaultValue={product.product_qty}
                                min="1"
                                max="1"
                                id={`edit-qty-${index}`}
                              />
                              <button
                                type="button"
                                className="rc-action-btn rc-action-btn--history"
                                onClick={() => {
                                  const productId = document.getElementById(`edit-product-${index}`).value;
                                  const productQty = document.getElementById(`edit-qty-${index}`).value;
                                  this.updateProduct(index, productId, productQty);
                                }}
                              >
                                <i className="fas fa-check"></i>
                                <span>Guardar</span>
                              </button>
                              <button
                                type="button"
                                className="rc-action-btn rc-action-btn--edit"
                                onClick={() => this.setState({ editingProductIndex: null })}
                              >
                                <i className="fas fa-times"></i>
                                <span>Cancelar</span>
                              </button>
                            </div>
                          ) : (
                            <div className="rc-product-view-row">
                              <span className="rc-product-name">
                                <i className="fas fa-box rc-card-row__icon"></i>
                                {product.product_name}
                                <span className="rc-product-qty">x{product.product_qty}</span>
                              </span>
                              <div className="rc-product-actions">
                                <button
                                  type="button"
                                  className="rc-action-btn rc-action-btn--edit"
                                  onClick={() => this.editProduct(index)}
                                >
                                  <i className="fas fa-pencil-alt"></i>
                                  <span>Editar</span>
                                </button>
                                <button
                                  type="button"
                                  className="rc-action-btn rc-action-btn--delete"
                                  onClick={() => this.removeProduct(index)}
                                >
                                  <i className="fas fa-trash-alt"></i>
                                  <span>Quitar</span>
                                </button>
                              </div>
                            </div>
                          )}
                        </div>
                      ))}
                    </div>
                  </div>
                </form>
              </div>
              <div className="vw-modal__footer">
                <button
                  type="button"
                  className="btn btn-light"
                  onClick={this.toggleForm}
                >
                  Cancelar
                </button>
                <button
                  type="button"
                  className="btn btn-vw"
                  onClick={this.handleSubmit}
                  disabled={
                    newRedeemCode.products.length === 0 ||
                    (role === 'ADMIN' && !newRedeemCode.customer)
                  }
                >
                  <i className="fas fa-plus-circle mr-2"></i>
                  Crear Código de Canje
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Stats Section */}
        <div className="rc-stats-grid">
          <div className="rc-stat-card">
            <div className="rc-stat-icon rc-stat-icon--total">
              <i className="fas fa-ticket"></i>
            </div>
            <div className="rc-stat-info">
              <div className="rc-stat-value">{redeemCodes.length}</div>
              <div className="rc-stat-label">Total Códigos</div>
            </div>
          </div>
          <div className="rc-stat-card">
            <div className="rc-stat-icon rc-stat-icon--active">
              <i className="fas fa-hourglass-half"></i>
            </div>
            <div className="rc-stat-info">
              <div className="rc-stat-value">
                {redeemCodes.filter(rc =>
                  (rc.multiple_redeems || !rc.redeemedAt || rc.redeemedAt.length === 0) &&
                  (!rc.valid_to || new Date(rc.valid_to) >= new Date())
                ).length}
              </div>
              <div className="rc-stat-label">Pendientes</div>
            </div>
          </div>
          <div className="rc-stat-card">
            <div className="rc-stat-icon rc-stat-icon--redeemed">
              <i className="fas fa-check-circle"></i>
            </div>
            <div className="rc-stat-info">
              <div className="rc-stat-value">
                {redeemCodes.filter(rc => !rc.multiple_redeems && rc.redeemedAt && rc.redeemedAt.length > 0).length}
              </div>
              <div className="rc-stat-label">Canjeados</div>
            </div>
          </div>
          <div className="rc-stat-card">
            <div className="rc-stat-icon rc-stat-icon--expired">
              <i className="fas fa-clock"></i>
            </div>
            <div className="rc-stat-info">
              <div className="rc-stat-value">
                {redeemCodes.filter(rc =>
                  (rc.multiple_redeems || !rc.redeemedAt || rc.redeemedAt.length === 0) &&
                  rc.valid_to && new Date(rc.valid_to) < new Date()
                ).length}
              </div>
              <div className="rc-stat-label">Expirados</div>
            </div>
          </div>
        </div>

        {/* Filter Bar */}
        {(() => {
          const customerIdsWithCodes = new Set(
            (redeemCodes || []).map(rc => rc.customer).filter(Boolean)
          );
          const hasActiveFilters = filterCode || filterCustomer || filterStatus !== 'all' || filterDateFrom || filterDateTo;
          return (
            <div className="rc-filter-bar">
              <div className="rc-filter-bar__row">
                <div className="rc-filter-item rc-filter-item--search">
                  <label className="rc-filter-label">Código</label>
                  <div className="rc-filter-input-wrap">
                    <i className="fas fa-search rc-filter-icon"></i>
                    <input
                      type="text"
                      className="rc-filter-input"
                      placeholder="Buscar código..."
                      value={filterCode}
                      onChange={e => this.setState({ filterCode: e.target.value })}
                    />
                  </div>
                </div>
                <div className="rc-filter-item">
                  <label className="rc-filter-label">Estado</label>
                  <select
                    className="rc-filter-input"
                    value={filterStatus}
                    onChange={e => this.setState({ filterStatus: e.target.value })}
                  >
                    <option value="all">Todos</option>
                    <option value="pending">Pendientes</option>
                    <option value="redeemed">Canjeados</option>
                    <option value="expired">Expirados</option>
                  </select>
                </div>
                {role === 'ADMIN' && customers && (
                  <div className="rc-filter-item">
                    <label className="rc-filter-label">Cliente</label>
                    <select
                      className="rc-filter-input"
                      value={filterCustomer}
                      onChange={e => this.setState({ filterCustomer: e.target.value })}
                    >
                      <option value="">Todos</option>
                      {customers
                        .filter(c => customerIdsWithCodes.has(c._id))
                        .sort((a, b) => a.Fullname.localeCompare(b.Fullname))
                        .map(c => (
                          <option value={c._id} key={c._id}>{c.Fullname}</option>
                        ))}
                    </select>
                  </div>
                )}
                <div className="rc-filter-item">
                  <label className="rc-filter-label">Válido desde</label>
                  <input
                    type="date"
                    className="rc-filter-input"
                    value={filterDateFrom}
                    onChange={e => this.setState({ filterDateFrom: e.target.value })}
                  />
                </div>
                <div className="rc-filter-item">
                  <label className="rc-filter-label">Válido hasta</label>
                  <input
                    type="date"
                    className="rc-filter-input"
                    value={filterDateTo}
                    onChange={e => this.setState({ filterDateTo: e.target.value })}
                  />
                </div>
                {hasActiveFilters && (
                  <div className="rc-filter-item rc-filter-item--clear">
                    <label className="rc-filter-label">&nbsp;</label>
                    <button
                      className="rc-btn-clear-filters"
                      onClick={() => this.setState({ filterCode: '', filterCustomer: '', filterStatus: 'all', filterDateFrom: '', filterDateTo: '' })}
                      title="Limpiar todos los filtros"
                    >
                      <i className="fas fa-filter-circle-xmark"></i>
                      <span>Limpiar filtros</span>
                    </button>
                  </div>
                )}
              </div>
            </div>
          );
        })()}

        {/* Cards Grid */}
        {filteredRedeemCodes.length === 0 ? (
          <div className="rc-empty-state">
            <i className="fas fa-search"></i>
            <p>No se encontraron códigos de canje</p>
          </div>
        ) : (
          <div className="rc-code-grid">
            {filteredRedeemCodes.map(redeemCode => {
              const status = this.getCodeStatus(redeemCode);
              return (
                <div key={redeemCode._id} className={`rc-code-card rc-code-card--${status}`}>
                  {/* Header: code + QR */}
                  <div className="rc-card-header">
                    <div className="rc-card-header__left">
                      <div className={`rc-card-code rc-card-code--${status}`}>{redeemCode.code}</div>
                      <div className="rc-card-header__pills">
                        <span className={`rc-status-pill rc-status-pill--${status}`}>
                          {status === 'redeemed' && <><i className="fas fa-check-circle"></i> Canjeado</>}
                          {status === 'expired'  && <><i className="fas fa-ban"></i> Expirado</>}
                          {status === 'pending'  && <><i className="fas fa-dot-circle"></i> Pendiente</>}
                        </span>
                        {redeemCode.multiple_redeems && (
                          <span className="rc-status-pill rc-status-pill--multi">
                            <i className="fas fa-redo"></i> Múltiple
                          </span>
                        )}
                      </div>
                    </div>
                    <button
                      className={`rc-qr-btn rc-qr-btn--${status}`}
                      onClick={() => this.showQRCode(redeemCode)}
                      title="Ver QR / Imprimir Voucher"
                    >
                      <i className="fas fa-qrcode"></i>
                      <span>Ver / Imprimir Voucher</span>
                    </button>
                  </div>

                  {/* Info rows */}
                  <div className="rc-card-body">
                    {redeemCode.products && redeemCode.products.length > 0 && (
                      <div className="rc-card-row">
                        <i className="fas fa-box rc-card-row__icon"></i>
                        <span>
                          {redeemCode.products.map(p =>
                            `${this.getTypeName(p.product_name) !== 'NONE' ? this.getTypeName(p.product_name) : p.product_name} ×${p.product_qty}`
                          ).join(', ')}
                        </span>
                      </div>
                    )}
                    {role === 'ADMIN' && (
                      <div className="rc-card-row">
                        <i className="fas fa-building rc-card-row__icon"></i>
                        <span>{this.getCustomerName(redeemCode.customer)}</span>
                      </div>
                    )}
                    <div className="rc-card-dates">
                      <div className="rc-card-date">
                        <i className="fas fa-calendar-check"></i>
                        <div>
                          <span>Válido desde</span>
                          <strong>
                            {redeemCode.valid_from
                              ? new Date(redeemCode.valid_from).toLocaleDateString('es-ES', { day: '2-digit', month: 'short', year: 'numeric' })
                              : 'Sin fecha'}
                          </strong>
                        </div>
                      </div>
                      <div className="rc-card-date-sep">→</div>
                      <div className="rc-card-date rc-card-date--to">
                        <i className="fas fa-calendar-times"></i>
                        <div>
                          <span>Válido hasta</span>
                          <strong>
                            {redeemCode.valid_to
                              ? new Date(redeemCode.valid_to).toLocaleDateString('es-ES', { day: '2-digit', month: 'short', year: 'numeric' })
                              : 'Sin fecha'}
                          </strong>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Footer */}
                  <div className="rc-card-footer">
                    <span className="rc-card-footer__date">
                      Creado {new Date(redeemCode.createdAt).toLocaleDateString('es-ES')}
                    </span>
                    <div className="rc-card-footer__actions">
                      {redeemCode.redeemedAt && redeemCode.redeemedAt.length > 0 && (
                        <button
                          className="rc-action-btn rc-action-btn--history"
                          onClick={() => this.showRedeemedModal(redeemCode)}
                          title="Ver historial"
                        >
                          <i className="fas fa-history"></i>
                          <span>Historial</span>
                        </button>
                      )}
                      <button
                        className="rc-action-btn rc-action-btn--edit"
                        onClick={() => this.openEditModal(redeemCode)}
                        title="Editar"
                      >
                        <i className="fas fa-pencil-alt"></i>
                        <span>Editar</span>
                      </button>
                      <button
                        className="rc-action-btn rc-action-btn--delete"
                        onClick={() => this.handleDeleteRedeemCode(redeemCode._id)}
                        title="Eliminar"
                      >
                        <i className="fas fa-trash-alt"></i>
                        <span>Eliminar</span>
                      </button>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}

        {showQRModal && selectedRedeemCode && (
          <div className="vw-modal">
            <div className="vw-modal__backdrop" onClick={this.closeQRModal} />
            <div className="vw-modal__dialog vw-modal__dialog--ticket">
              <div className="vw-modal__header">
                <h5 className="m-0">
                  <i className="fas fa-ticket mr-2" style={{ color: '#0b97ff' }}></i>
                  Vale de Canje
                </h5>
                <button
                  type="button"
                  className="close"
                  onClick={this.closeQRModal}
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="vw-modal__body ticket-modal-body">
                <div className="ticket-voucher" id="qr-ticket-print">
                  {/* Ticket Header */}
                  <div className="ticket-header">
                    <div className="ticket-brand">VACWAY</div>
                    <div className="ticket-subtitle">Vale de Canje</div>
                  </div>
                  {/* Tear Line */}
                  <div className="ticket-tear">
                    <div className="notch"></div>
                    <div className="dashes"></div>
                    <div className="notch"></div>
                  </div>
                  {/* Ticket Body */}
                  <div className="ticket-body">
                    <div className="ticket-qr">
                      <QRCode
                        value={selectedRedeemCode.code}
                        size={180}
                        level={"H"}
                        includeMargin={true}
                      />
                    </div>
                    <div className="ticket-code-label">CÓDIGO</div>
                    <div className="ticket-code">{selectedRedeemCode.code}</div>
                    {selectedRedeemCode.products && selectedRedeemCode.products.length > 0 && (
                      <div className="ticket-product-chip">
                        <i className="fas fa-box mr-1"></i>
                        {selectedRedeemCode.products.map(p =>
                          `${this.getTypeName(p.product_name) !== 'NONE' ? this.getTypeName(p.product_name) : p.product_name} x${p.product_qty}`
                        ).join(', ')}
                      </div>
                    )}
                    <div className="ticket-validity">
                      <div className="validity-item">
                        <span>Válido Desde</span>
                        <strong>
                          {selectedRedeemCode.valid_from
                            ? new Date(selectedRedeemCode.valid_from).toLocaleDateString('es-ES', { day: '2-digit', month: 'short', year: 'numeric' })
                            : '—'}
                        </strong>
                      </div>
                      <div className="validity-item">
                        <span>Válido Hasta</span>
                        <strong>
                          {selectedRedeemCode.valid_to
                            ? new Date(selectedRedeemCode.valid_to).toLocaleDateString('es-ES', { day: '2-digit', month: 'short', year: 'numeric' })
                            : '—'}
                        </strong>
                      </div>
                    </div>
                  </div>
                  {/* Ticket Footer */}
                  <div className="ticket-footer">
                    Presenta este QR en la máquina VACWAY para canjear
                  </div>
                </div>
              </div>
              <div className="vw-modal__footer">
                <button
                  type="button"
                  className="btn btn-light"
                  onClick={this.closeQRModal}
                >
                  Cerrar
                </button>
                <button
                  type="button"
                  className="btn btn-vw"
                  onClick={this.printTicket}
                >
                  <i className="fas fa-print mr-2"></i>
                  Imprimir Voucher
                </button>
              </div>
            </div>
          </div>
        )}

        {showRedeemedModal && selectedRedeemedCode && (
          <div className="vw-modal">
            <div
              className="vw-modal__backdrop"
              onClick={this.closeRedeemedModal}
            />
            <div className="vw-modal__dialog vw-modal__dialog--redeemed">
              <div className="vw-modal__header">
                <h5 className="m-0">
                  Historial de Canjes - {selectedRedeemedCode.code}
                </h5>
                <button
                  type="button"
                  className="close"
                  onClick={this.closeRedeemedModal}
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="vw-modal__body">
                <div className="list-group">
                  {selectedRedeemedCode.redeemedAt.map((redeem, index) => (
                    <div key={index} className="list-group-item">
                      <div
                        className="d-flex flex-wrap justify-content-between align-items-center"
                        style={{ gap: "10px" }}
                      >
                        <div style={{ minWidth: "250px" }}>
                          <strong>Fecha de canje:</strong>{" "}
                          {new Date(redeem.redeem_timestamp).toLocaleString()}
                        </div>
                        <div style={{ minWidth: "150px" }}>
                          <strong>Máquina:</strong> {this.getMachineSerial(redeem.redeem_machine)}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <div className="vw-modal__footer">
                <button
                  type="button"
                  className="btn btn-light"
                  onClick={this.closeRedeemedModal}
                >
                  Cerrar
                </button>
              </div>
            </div>
          </div>
        )}

        {this.state.showEditModal && this.state.editRedeemCode && (
          <div className="vw-modal">
            <div className="vw-modal__backdrop" onClick={this.closeEditModal} />
            <div className="vw-modal__dialog">
              <div className="vw-modal__header">
                <h5 className="m-0">Editar Código de Canje</h5>
                <button
                  type="button"
                  className="close"
                  onClick={this.closeEditModal}
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="vw-modal__body">
                <form>
                  <div className="form-group">
                    <label htmlFor="edit-code">Código</label>
                    <input
                      type="text"
                      className="form-control"
                      id="edit-code"
                      name="code"
                      value={this.state.editRedeemCode.code}
                      onChange={this.handleEditInputChange}
                      placeholder="Dejar vacío para generar automáticamente"
                    />
                  </div>

                  {role === "ADMIN" && (
                    <div className="form-group">
                      <label htmlFor="edit-customer">Cliente</label>
                      <select
                        className="form-control"
                        id="edit-customer"
                        name="customer"
                        value={this.state.editRedeemCode.customer}
                        onChange={this.handleEditInputChange}
                        required
                      >
                        <option value="">Seleccionar cliente</option>
                        {customers &&
                          customers
                            .filter((customer) => customer.Type === "GENERAL" || customer.Type === "LICENCIA_BASICA" || customer.Type === "LICENCIA_PRO")
                            .sort((a, b) =>
                              a.Fullname.localeCompare(b.Fullname)
                            )
                            .map((customer) => (
                              <option key={customer._id} value={customer._id}>
                                {customer.Fullname}
                              </option>
                            ))}
                      </select>
                    </div>
                  )}

                  <div className="form-group">
                    <label htmlFor="edit-valid_from">Válido Desde</label>
                    <input
                      type="datetime-local"
                      className="form-control"
                      id="edit-valid_from"
                      name="valid_from"
                      value={this.state.editRedeemCode.valid_from}
                      onChange={this.handleEditInputChange}
                      required
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="edit-valid_to">Válido Hasta</label>
                    <input
                      type="datetime-local"
                      className="form-control"
                      id="edit-valid_to"
                      name="valid_to"
                      value={this.state.editRedeemCode.valid_to}
                      onChange={this.handleEditInputChange}
                      required
                    />
                  </div>

                  <div className="rc-form-group" style={{ marginBottom: '16px' }}>
                    <label className="rc-form-label">
                      <i className="fas fa-redo"></i> Canje Múltiple
                    </label>
                    <label className="rc-toggle-row">
                      <input
                        type="checkbox"
                        className="rc-toggle-input"
                        name="multiple_redeems"
                        checked={this.state.editRedeemCode.multiple_redeems || false}
                        onChange={e => this.setState({ editRedeemCode: { ...this.state.editRedeemCode, multiple_redeems: e.target.checked } })}
                      />
                      <span className="rc-toggle-track"></span>
                      <span className="rc-toggle-label-text">
                        {this.state.editRedeemCode.multiple_redeems
                          ? "Activado — el código puede canjearse múltiples veces"
                          : "Desactivado — el código solo puede canjearse una vez"}
                      </span>
                    </label>
                  </div>

                  <div className="form-group">
                    <label>Productos</label>
                    <div
                      className="d-flex align-items-center mb-2"
                      style={{ gap: "10px" }}
                    >
                      <select
                        className="form-control"
                        name="editProductId"
                        value={this.state.editProductId}
                        onChange={this.handleEditProductChange}
                        style={{ flex: 1 }}
                      >
                        <option value="">Seleccionar tipo de taquilla</option>
                        {LOCKER_TYPES.map((locker) => (
                          <option value={locker.code} key={locker.code}>
                            {locker.name}
                          </option>
                        ))}
                      </select>
                      <input
                        type="number"
                        className="form-control"
                        name="editProductQty"
                        value={this.state.editProductQty}
                        onChange={this.handleEditProductChange}
                        placeholder="Cantidad"
                        min="1"
                        max="1"
                        style={{ width: "80px" }}
                      />
                      <button
                        type="button"
                        className="btn btn-vw"
                        onClick={this.addEditProduct}
                        disabled={this.state.editRedeemCode.products.length >= 1}
                      >
                        Añadir
                      </button>
                    </div>
                    {this.state.editRedeemCode.products.length >= 1 && (
                      <small className="text-warning">
                        <i className="fas fa-info-circle mr-1"></i>
                        Solo se permite 1 producto por código
                      </small>
                    )}
                    <ul className="list-group">
                      {this.state.editRedeemCode.products.map((product, index) => (
                        <li key={index} className="list-group-item">
                          {this.state.editingEditProductIndex === index ? (
                            <div
                              className="d-flex align-items-center"
                              style={{ gap: "10px" }}
                            >
                              <select
                                className="form-control"
                                defaultValue={product.product_id}
                                id={`edit-edit-product-${index}`}
                                style={{ flex: 1 }}
                              >
                                {LOCKER_TYPES.map((locker) => (
                                  <option value={locker.code} key={locker.code}>
                                    {locker.name}
                                  </option>
                                ))}
                              </select>
                              <input
                                type="number"
                                className="form-control"
                                defaultValue={product.product_qty}
                                min="1"
                                max="1"
                                id={`edit-edit-qty-${index}`}
                                style={{ width: "80px" }}
                              />
                              <button
                                type="button"
                                className="btn btn-sm btn-success"
                                onClick={() => {
                                  const productId = document.getElementById(
                                    `edit-edit-product-${index}`
                                  ).value;
                                  const productQty = document.getElementById(
                                    `edit-edit-qty-${index}`
                                  ).value;
                                  this.updateEditProduct(
                                    index,
                                    productId,
                                    productQty
                                  );
                                }}
                              >
                                Guardar
                              </button>
                              <button
                                type="button"
                                className="btn btn-sm btn-secondary"
                                onClick={() =>
                                  this.setState({ editingEditProductIndex: null })
                                }
                              >
                                Cancelar
                              </button>
                            </div>
                          ) : (
                            <div className="d-flex justify-content-between align-items-center">
                              <span>
                                {product.product_name} - Cant:{" "}
                                {product.product_qty}
                              </span>
                              <div style={{ display: "flex", gap: "5px" }}>
                                <button
                                  type="button"
                                  className="btn btn-sm btn-primary"
                                  onClick={() => this.editEditProduct(index)}
                                >
                                  Editar
                                </button>
                                <button
                                  type="button"
                                  className="btn btn-sm btn-danger"
                                  onClick={() => this.removeEditProduct(index)}
                                >
                                  Eliminar
                                </button>
                              </div>
                            </div>
                          )}
                        </li>
                      ))}
                    </ul>
                  </div>
                </form>
              </div>
              <div className="vw-modal__footer">
                <button
                  type="button"
                  className="btn btn-light"
                  onClick={this.closeEditModal}
                >
                  Cancelar
                </button>
                <button
                  type="button"
                  className="btn bg-vw-dark text-white"
                  onClick={this.handleEditSubmit}
                >
                  Actualizar Código de Canje
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  role: state.auth.role,
  type: state.auth.type,
  customerId: state.auth.id,
  customerFullname: state.auth.fullname,
  customer: state.customers.customer,
  redeemCodes: state.redeemCodes.redeemCodes,
  redeemCodesNeedRefresh: state.redeemCodes.redeemCodesNeedRefresh,
  loading: state.redeemCodes.loading,
  error: state.redeemCodes.error,
  machines: state.machines.machines,
  customers: state.customers.customers,
});

const mapDispatchToProps = (dispatch) => ({
  fetchRedeemCodes: bindActionCreators(fetchRedeemCodes, dispatch),
  addRedeemCode: bindActionCreators(addRedeemCode, dispatch),
  updateRedeemCode: bindActionCreators(updateRedeemCode, dispatch),
  deleteRedeemCode: bindActionCreators(deleteRedeemCode, dispatch),
  fetchMachines: bindActionCreators(fetchMachines, dispatch),
  fetchCustomersName: bindActionCreators(fetchCustomersName, dispatch),
  fetchCustomer: bindActionCreators(fetchCustomer, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(RedeemCodesView);
